import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function SiteHeader({ active }) {
    return (
        <header className="sticky top-0 z-40 border-b border-divider bg-bone/95 backdrop-blur-sm" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
                    <Logo size={36} className="text-moss" />
                    <div className="leading-none">
                        <div className="font-serif text-xl tracking-tight text-ink">Noble Accounting Services</div>
                        <div className="text-[10px] uppercase tracking-[0.25em] text-ash mt-0.5">A Zakir Dema Company · Est. 2010</div>
                    </div>
                </Link>
                <nav className="hidden md:flex items-center gap-8 text-sm">
                    <Link
                        to="/"
                        className={`${active === "home" ? "text-ink" : "text-ash"} hover:text-ink transition-colors`}
                        data-testid="nav-home"
                    >
                        Home
                    </Link>
                    <Link
                        to="/book"
                        className={`${active === "book" ? "text-ink" : "text-ash"} hover:text-ink transition-colors`}
                        data-testid="nav-book"
                    >
                        Book
                    </Link>
                    <Link
                        to="/kiosk"
                        className={`${active === "kiosk" ? "text-ink" : "text-ash"} hover:text-ink transition-colors`}
                        data-testid="nav-kiosk"
                    >
                        Kiosk
                    </Link>
                    <Link
                        to="/staff/login"
                        className="text-moss hover:text-moss-hover transition-colors font-medium"
                        data-testid="nav-staff"
                    >
                        Staff Login →
                    </Link>
                </nav>
                <Link
                    to="/book"
                    className="md:hidden px-4 py-2 bg-moss text-bone text-sm hover:bg-moss-hover transition-colors"
                    data-testid="nav-book-mobile"
                >
                    Book
                </Link>
            </div>
        </header>
    );
}
